
import { Base } from '../base-component';

import './value-proposition.component.scss';

export class ValueProposition extends Base {

	constructor(element: Element){

		super(element);
				
	}

	init(){}

	bindEvents() {}
	
}



// WEBPACK FOOTER //
// ./components/value-proposition/value-proposition.component.ts